<script lang="ts" setup>
import NewsItem from './NewsItem.vue'
import { useArticleStore } from '@/stores'
import { computed } from 'vue';

const route = useRoute()
const router = useRouter()
const articleStore = useArticleStore()
const newsList = computed(() => articleStore.getNewsList)
const currentNewsCategory = computed(() => articleStore.getCurrentNewsCategory)
const pageMeta = computed(() => articleStore.getPageMeta)
const page = ref(parseInt(route.query.page as string || '1'))
const handleChangePage = (page: number) => {
  router.push(`${route.path}?page=${page}`)
  articleStore.fetchArticleNewsList(currentNewsCategory.value?.id, page)
}
watch(
  () => page.value,
  () => {
    setTimeout(() => {
      const locationIntroDom = document.querySelector('body')
      if (locationIntroDom) {
        locationIntroDom.scrollIntoView();
      }
    }, 300)
  }
)
</script>

<template>
  <div>
    <ul class="lists">
      <li v-for="(item, index) in newsList" :key="item.id">
        <NewsItem :reverse="index === 0 ? true : false" :rectangle="item.thumbnail_style === 'B' ? true : false"
          :item="item" />
      </li>
    </ul>
    <Pagination v-if="pageMeta !== null && pageMeta?.per_page <= pageMeta?.total" class="h-pagination center"
      layout="prev, pager, next" v-model:page="page" :per-page="pageMeta?.per_page" :total="pageMeta?.total"
      :handleChangePage="handleChangePage" />
  </div>
</template>

<style lang="scss" scoped>
.lists {
  width: 100%;

  li {
    margin-bottom: toRem(100);

    @include max-media(640) {
      margin-bottom: toRem(55);
    }
  }
}
</style>
